'use strict'

// Import
import moment from 'moment'

// Class

class Format {
  // Generate all styled formats
  static parseIntDate (timestamp) {
    const dateformat = moment.unix(timestamp).format('YYYYMMDDHHmmss')
    return parseInt(dateformat).toString(16)
  }

  static timestampToDate (timestamp) {
    let seconds = timestamp.seconds
    const date = new Date(seconds * 1000)
    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]
    var year = date.getFullYear()
    var month = months[date.getMonth()]
    var _date = date.getDate()
    var time = _date + ' ' + month + ', ' + year
    return time
  }
  static FirestoreDateToMoment = timestamp => {
    let seconds = timestamp.seconds
    const date = new Date(seconds * 1000)
    return moment(date)
  }
  static strFrom = value => {
    let type = Format._getStrFromType(value)
    let name = 'strFrom' + type

    let func = Format[name]

    let resp = func(value)
    return resp
  };

  static strFromAny = value => (value || 'none').toString();

  static strFromObject = value => JSON.stringify(value);

  static strFromFunction = func => {
    let value = awaitCallback(func)
    return Format.strFrom(value)
  };

  static strFromPromise = prom => {
    let value = awaitPromise(prom)
    return Format.strFrom(value)
  };

  static _getStrFromType = value => {
    if (value instanceof Promise) {
      return 'Promise'
    }
    if (value instanceof Function) {
      return 'Function'
    }
    if (value instanceof Object) {
      return 'Object'
    }
    return 'Any'
  };
}

function awaitPromise (promise) {
  return promise._55
}

function awaitCallback (func) {
  let promiseCallback = new Promise(resolve => {
    try {
      func(value => resolve(value))
    } catch (error) {
      resolve('none')
    }
  })
  let value = awaitPromise(promiseCallback)
  return value
}

export const isExpired = (expiredDateTimestamp = {seconds: 0}) => {
  let today = Math.floor(Date.now() / 1000)
  if (!expiredDateTimestamp) {
    return false
  }
  return today > expiredDateTimestamp.seconds
}

export const dateTimeAgo = (timestamp, tzInc = 0) => {
  var datetimeString = Format.FirestoreDateToMoment(timestamp)
  var result = ''
  var justNow = moment()
  var dateAgo = datetimeString
  var minAgo = justNow.diff(dateAgo, 'minutes')
  var today = justNow.diff(justNow.clone().startOf('day'), 'minutes')
  var yesterday = today + (24 * 60) // justNow.diff(justNow.clone().subtract(1, 'day').startOf('day'), 'minutes');
  var onYear = justNow.diff(justNow.clone().startOf('year'), 'minutes')
  result = result || ((minAgo < 1) && 'Right now')
  result = result || ((minAgo === 1) && '1 minute ago')
  result = result || ((minAgo < 60) && (minAgo + ' minutes ago'))
  result = result || ((minAgo < 90) && '1 hour ago')
  result = result || ((minAgo < today) && Math.round(minAgo / 60) + ' hours ago')
  result = result || ((minAgo < yesterday) && 'Yesterday')
  result = result || ((minAgo < onYear) && dateAgo.format('DD MMM'))
  result = result || dateAgo.format('DD MMM, YYYY')
  return result
}

export default Format



// WEBPACK FOOTER //
// ./src/helper/Format.js